export const ViewAllGrnConfig = {
  columns: [
    {
      headerName: "Invoice No.",
      mappedValue: "invoiceNumber",
      width: 170,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Invoice Date & Time",
      mappedValue: "creationTime",
      width: 170,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Quantity",
      mappedValue: "totalInitialCaseQuantity, totalInitialPieceQuantity, totalInitialOtherQuantity",
      width: 120,
      headerAlign: "left",
      align: "left",
      type: "viewprimaryorderconfigs",
    },
    {
      headerName: "Amount",
      mappedValue: "netAmount",
      width: 120,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "Order Status",
      mappedValue: "status",
      width: 170,
      headerAlign: "left",
      align: "left",
    },
    {
      headerName: "GRN Status",
      mappedValue: " ",
      width: 170,
      headerAlign: "left",
      align: "left",
      type: "grn",
    },
  ],
  Actions: ["view", "download"],
};
